import { getDeliveryOptions as getDeliveryOptionsFromApi } from "@src/api/index";
import { getOrSetInLocalStorageWithExpiryAsync } from "@src/helpers/webStorage";
import {
  RSFT_DELIVERY_OPTIONS_CACHE_TTL_MS,
  RSFT_DELIVERY_OPTIONS_LOCAL_STORAGE_PREFIX
} from "@template/constants";

const deliveryOptionsGetter = async (resolvedDeliveryCountry, storeId) => {
  const value = await getDeliveryOptionsFromApi(
    resolvedDeliveryCountry,
    storeId
  );
  const timeToLiveMs = RSFT_DELIVERY_OPTIONS_CACHE_TTL_MS;

  return { value, timeToLiveMs };
};

export const getAreDeliveryOptionsAvailable = async (
  resolvedDeliveryCountry,
  storeId
) => {
  const deliveryOptions = await getOrSetInLocalStorageWithExpiryAsync(
    {
      cacheKeyPrefix: RSFT_DELIVERY_OPTIONS_LOCAL_STORAGE_PREFIX,
      returnCachedOnDelegateFailure: false,
      removeOtherCacheItems: false,
      localStorageValueDelegate: deliveryOptionsGetter
    },
    resolvedDeliveryCountry,
    storeId
  );

  return !!deliveryOptions.countries[0].deliveryMethods.length;
};
